export default __webpack_public_path__ + "static/media/couloir.6d816992.png";